module.exports = __webpack_public_path__ + "img/novo-logo-f360.7a64e1fa.png";